module.exports = __webpack_public_path__ + "img/qq.228bb46c.png";